<template>
  <div>元件載入錯誤，請重新整理瀏覽器</div>
</template>

<script>
export default {
  name: 'ComponentError'
}
</script>
